/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { GpsSaMapLayer } from '../../shared/entities/gpsSaMapLayer';
import ActionCreator from '../action-creator';

interface ReceivedGpsSaMapLayersSuccessProps {
  status: number;
  eTag: string;
  response: GpsSaMapLayer[];
}

export const ActionCreators = {
  // For requesting GPS SA aggregated map layers
  RequestGpsSaMapLayers: new ActionCreator<'RequestGpsSaMapLayers', any>('RequestGpsSaMapLayers'),
  ReceivedGpsSaMapLayersSuccess: new ActionCreator<'ReceivedGpsSaMapLayersSuccess', ReceivedGpsSaMapLayersSuccessProps>(
    'ReceivedGpsSaMapLayersSuccess',
  ),
  ReceivedGpsSaMapLayersError: new ActionCreator<'ReceivedGpsSaMapLayersError', any>('ReceivedGpsSaMapLayersError'),
  ClearReceivedGpsSaMapLayersError: new ActionCreator<'ClearReceivedGpsSaMapLayersError', any>(
    'ClearReceivedGpsSaMapLayersError',
  ),
  CancelRequestGpsSaMapLayersPoll: new ActionCreator<'CancelRequestGpsSaMapLayersPoll', any>(
    'CancelRequestGpsSaMapLayersPoll',
  ),
};

export type Action = typeof ActionCreators[keyof typeof ActionCreators];

export function requestGpsSaMapLayers() {
  return ActionCreators.RequestGpsSaMapLayers.create();
}
export function clearReceivedGpsSaMapLayersError() {
  return ActionCreators.ClearReceivedGpsSaMapLayersError.create();
}
export function cancelRequestGpsSaMapLayersPoll() {
  return ActionCreators.CancelRequestGpsSaMapLayersPoll.create();
}
